import useSimplePage from "@/hooks/useSimplePage";

export default function CookiesPrivacyContent() {
  const page = useSimplePage("cookies");

  return (
    <div className="container">
      <div className="pb-28">
        <div className="text-xl/8 text-black">
          {page && <div dangerouslySetInnerHTML={{ __html: page?.content }} />}
        </div>
      </div>
    </div>
  );
}
